import React from "react";
import { BsGithub } from "react-icons/bs";
import { FaLinkedinIn } from "react-icons/fa";

const SocialMedia = () => {
  return (
    <div className="app__social">
      <div>
        <a href="https://github.com/LoudFellow" target="blank" rel="noreferrer">
          <BsGithub />
        </a>
      </div>
      <div>
        <a
          href="https://www.linkedin.com/in/ioannis-tsakiridis-5a4ba5181/"
          target="blank"
          rel="noreferrer"
        >
          <FaLinkedinIn />
        </a>
      </div>
    </div>
  );
};

export default SocialMedia;
